<script setup lang="ts">
import { ref,reactive,onMounted,onBeforeUnmount,toRefs,watch, computed } from 'vue'
import CustomList from "../../../../compositions/CustomList.vue";
import ModalDialog from "../../../../compositions/ModalDialog.vue";
import SearchBox from "../../../../compositions/SearchBox.vue";
import SelectBox from "../../../../compositions/SelectBox.vue";
import Chart from "../../../../compositions/Chart.vue";
import SummaryMedicineComponent from '../../../Common/SummaryMedicineComponent.vue';
import config from "../../../../config.js";
import { errorAlert } from "../../../../plugins/alert";
import { getDistinctColors } from "../../../../plugins/utility";
import qs from 'qs';
import axios from '../../../../plugins/axios.ts';
import { deepCopy } from "../../../../plugins/utility";
import HelpAction from '../../../../compositions/HelpAction.vue';
import axios_org from 'axios';
import { color } from 'chart.js/helpers';

const props = defineProps({
    apis:{
      type:Object,
      required:true,
    },
    searchParams: {
      typ:Object,
      default:() => {
        return {};
      }
    },
    isVisible:{
        type:Boolean,
        default: () => {
            return false;
        }
    }
})

let cancelSummary = null;
let cancelSummaryHistory = null;
let cancelSummaryStockAggregate = null;

const { isVisible,identityId,searchParams } = toRefs(props);
const listMedicineSummaryJanRef = ref();
const searchParamsData = reactive(props.searchParams);
const searchParamsJanData = reactive({});
for (let key in props.searchParams) {
  searchParamsJanData[key] = props.searchParams[key];
}
searchParamsJanData.is_summary = 1;
const medicineSummaryJanFields = reactive([
  {field_name: '薬局名', field_key: 'pharmacy_name', width: '5%', align: 'text-left',sorted:true},
  {field_name: '採用品', field_key: 'product_detail_name', width: '10%', align: 'text-left',sorted:true},
  {field_name: '最新<br>薬価', field_key: 'medicine_unit_price', width: '5%', align: 'text-center',sorted:true},
  {field_name: '最新<br>購入額', field_key: 'current_unit_price', width: '5%', align: 'text-center',sorted:true},
  {field_name: '最新購入額<br>在庫金額', field_key: 'current_unit_stock_price', width: '5%', align: 'text-center',sorted:true},
  {field_name: '在庫数', field_key: 'real_stock_number', width: '5%', align: 'text-center',sorted:true},
  {field_name: '仕入れ<br>金額(税込)', field_key: 'van_stock_price', width: '5%', align: 'text-center',sorted:true},
  {field_name: '処方数量', field_key: 'prescript_count', width: '5%', align: 'text-center',sorted:true},
  {field_name: '販売<br>金額(税込)', field_key: 'prescript_price', width: '5%', align: 'text-center',sorted:true},
  {field_name: '小分け購入<br>金額(税込)', field_key: 'pack_buy_stock_price', width: '5%', align: 'text-center',sorted:true},
  {field_name: '小分け販売<br>金額(税込)', field_key: 'pack_sell_stock_price', width: '5%', align: 'text-center',sorted:true},
  {field_name: '廃棄金額(税込)', field_key: 'delete_price', width: '5%', align: 'text-center',sorted:true},
  {field_name: '廃棄数', field_key: 'delete_number', width: '5%', align: 'text-center',sorted:true},
  {field_name: '使用期限', field_key: 'expire_date', width: '5%', align: 'text-center',sorted:true},
]);
const summaryData = reactive([]);
const summaryChartData = reactive([]);
const summaryChartHistoryData = reactive([]);
const summaryChartStockAggregateData = reactive([]);
const summaryHistoryType = ref(1);
const summaryHistoryOptions = reactive([
  {id:0,name:'年単位'},
  {id:1,name:'月単位'},
]);
const onSummaryHistoryTypeChange = (value,label) => {
  summaryHistoryType.value = value;
  getSummaryHistory();
}
const getSummary = async () => {
  let params = deepCopy(searchParamsData);
  const paramsSerializer = (params) => qs.stringify(params,{ arrayFormat: 'repeat'});
  let response = await axios.get(props.apis.summary_stock_summary,{params:params,paramsSerializer,cancelToken:  new axios_org.CancelToken((c) => {
        cancelSummary = c;
      })});
  summaryData.splice(0);
  summaryData.push(response.data.summary);
  let chartPieRecord = {};
  chartPieRecord.labels = ['処方','卸発注','小分け','不動品','廃棄'];
  let pieData = [
    response.data.summary.prescript_price,
    response.data.summary.van_stock_price,
    response.data.summary.pack_buy_stock_price,
    response.data.summary.pharmacy_medicine_old_price,
    response.data.summary.delete_price,
  ]
  let allPrice = 0;
  for (let i=0;i<pieData.length;i++) {
    allPrice += pieData[i];
  }
  for (let i=0;i<pieData.length;i++) {
    pieData[i] = Math.round((pieData[i] / allPrice)*100);
  }
  chartPieRecord.datasets = [
    {
      type:'pie',
      label:'取引金額割合',
      backgroundColor:['#00fd02','#FF6384','#36A2EB','#FF0000','#793c00'],
      data:pieData,
    }
  ];
  summaryChartData.splice(0);
  summaryChartData.push(chartPieRecord);
}
const getSummaryHistory = async () => {
  let params = deepCopy(searchParamsData);
  params['history_type'] = summaryHistoryType.value;
  const paramsSerializer = (params) => qs.stringify(params,{ arrayFormat: 'repeat'});
  let response = await axios.get(props.apis.summary_stock_summary_list,{params:params,paramsSerializer,cancelToken:  new axios_org.CancelToken((c) => {
        cancelSummaryHistory = c;
      })});
  let chartRecord = {};
  chartRecord.labels = [];
  for (let i=0;i<response.data.list.length;i++) {
    chartRecord.labels.push(response.data.list[i].summary_key);
  }
  chartRecord.datasets = [];
  let prescript_price = [];
  let van_stock_price = [];
  let pack_buy_stock_price = [];
  let pack_sell_stock_price = [];
  let delete_price = [];
  for (let i=0;i<response.data.list.length;i++) {
    prescript_price.push(response.data.list[i].prescript_price);
    van_stock_price.push(response.data.list[i].van_stock_price);
    pack_buy_stock_price.push(response.data.list[i].pack_buy_stock_price);
    pack_sell_stock_price.push(response.data.list[i].pack_sell_stock_price);
    delete_price.push(response.data.list[i].delete_price);
  }
  chartRecord.datasets.push({
      type:'bar',
      label:'処方',
      backgroundColor:'#00fd02',
      data:prescript_price,
  });
  chartRecord.datasets.push({
      type:'bar',
      label:'卸発注',
      backgroundColor:'#FF6384',
      data:van_stock_price,
  });
  chartRecord.datasets.push({
      type:'bar',
      label:'小分け購入',
      backgroundColor:'#36A2EB',
      data:pack_buy_stock_price,
  });
  chartRecord.datasets.push({
      type:'bar',
      label:'小分け販売',
      backgroundColor:'#360d7f',
      data:pack_sell_stock_price,
  });
  chartRecord.datasets.push({
      type:'bar',
      label:'廃棄',
      backgroundColor:'#793c00',
      data:delete_price,
  });
  summaryChartHistoryData.splice(0);
  summaryChartHistoryData.push(chartRecord);
}

const getSummaryStockAggregate = async () => {
  let params = deepCopy(searchParamsData);
  //すべて取得する
  params.page_size = 100000;
  const paramsSerializer = (params) => qs.stringify(params,{ arrayFormat: 'repeat'});
  let response = await axios.get(props.apis.summary_stock_aggregate_month_avg_summary_list,{params:params,paramsSerializer,cancelToken:  new axios_org.CancelToken((c) => {
        cancelSummaryStockAggregate = c;
      })});
  let chartRecord = {};
  chartRecord.labels = [];
  for (let i=0;i<response.data.month_period.length;i++) {
    chartRecord.labels.push(response.data.month_period[i]);
  }
  chartRecord.datasets = [];
  let colors = getDistinctColors(Object.keys(response.data.list).length);
  let colorIndex = 0;
  for (let pharmacyName in response.data.list) {
    chartRecord.datasets.push({
        type:'bar',
        label:pharmacyName,
        backgroundColor:colors[colorIndex],
        data:response.data.list[pharmacyName],
    });
    colorIndex++;
  }
  summaryChartStockAggregateData.splice(0);
  summaryChartStockAggregateData.push(chartRecord);
}
//////////// 月別在庫金額
const listMedicineSummaryAggregateRef = ref();
const searchParamsAggregateData = reactive({});
for (let key in props.searchParams) {
  searchParamsAggregateData[key] = props.searchParams[key];
}
const medicineSummaryAggregateFields = reactive([
  {field_name: '薬局名', field_key: 'pharmacy_name', width: '25%', align: 'text-left',sorted:true},
  {field_name: '集計月', field_key: 'aggregate_date', width: '10%', align: 'text-left',sorted:true},
  {field_name: '在庫金額', field_key: 'stock_price', width: '10%', align: 'text-left',sorted:true},
  {field_name: '処方金額', field_key: 'prescript_price', width: '10%', align: 'text-left',sorted:true},
  {field_name: '在庫月数', field_key: 'month_avg', width: '10%', align: 'text-left',sorted:false},
]);
///////////////////////////
const refreshListView = () => {
  listMedicineSummaryJanRef.value.resetItem();
  listMedicineSummaryAggregateRef.value.resetItem();
}
const refreshView = () => {
  if (isVisible.value == false) {
    return;
  }
  if (typeof listMedicineSummaryJanRef.value !== 'undefined') {
    refreshListView();
    getSummary();
    getSummaryHistory();
    getSummaryStockAggregate();
  }
}
watch(isVisible,(newValue, oldValue) => {
  if (newValue) {
    refreshView();
  }
})

watch(searchParams,(newValue, oldValue) => {
  for (let key in newValue) {
    searchParamsJanData[key] = newValue[key];
    searchParamsAggregateData[key] = newValue[key];
  }
  if (cancelSummary) {
    cancelSummary();
    cancelSummary = null;
  }
  if (cancelSummaryHistory) {
    cancelSummaryHistory();
    cancelSummaryHistory = null;
  }
  if (cancelSummaryStockAggregate) {
    cancelSummaryStockAggregate();
    cancelSummaryStockAggregate = null;
  }
  refreshView();
},{deep:true})

onMounted(() => {
  refreshView();
});

</script>

<style scoped>
.active {
  --tw-text-opacity: 1;
  color: rgb(242 140 31 / var(--tw-text-opacity));
  --tw-border-opacity: 1;
  border-color: rgb(242 140 31 / var(--tw-border-opacity));
  border-bottom-width: 2px;
}
.active > svg {
  --tw-text-opacity: 1;
  color: rgb(242 140 31 / var(--tw-text-opacity));
}
a.active:hover {
  --tw-text-opacity: 1;
  color: rgb(242 140 31 / var(--tw-text-opacity));
}
.active > svg:hover {
  --tw-text-opacity: 1;
  color: rgb(242 140 31 / var(--tw-text-opacity));
}
.summary-header {
  min-height:54px;
}
.summary-chart1 {
  min-height:342px;
}
.summary-chart2 {
  min-height:342px;
}
</style>
<template>
<div v-show="isVisible" class="relative">
  <div class="absolute top-2 left-2" style="z-index:39;">
    <help-action
      help-key="dashboard_summary_help"
    ></help-action>
  </div>
  <div class="pl-8 w-full border flex items-center flex-wrap px-4 summary-header" v-for="(summaryRecord,index) in summaryData" :key="index">
    <div class="text-center">
      <div><span class="mx-4 border-b text-sm">仕入れ金額(税込み)</span></div>
      <div class="text-bold text-lg">\{{ summaryRecord.van_stock_price.toLocaleString() }}</div>
    </div>
    <div class="text-center">
      <div><span class="mx-4 border-b text-sm">小分け購入金額(税込み)</span></div>
      <div class="text-bold text-lg">\{{ summaryRecord.pack_buy_stock_price.toLocaleString() }}</div>
    </div>
    <div class="text-center">
      <div><span class="mx-4 border-b text-sm">小分け購入回数</span></div>
      <div class="text-bold text-lg">{{ summaryRecord.pack_buy_stock_count }}</div>
    </div>
    <div class="text-center">
      <div><span class="mx-4 border-b text-sm">小分け販売金額(税込み)</span></div>
      <div class="text-bold text-lg">\{{ summaryRecord.pack_sell_stock_price.toLocaleString() }}</div>
    </div>
    <div class="text-center">
      <div><span class="mx-4 border-b text-sm">小分け販売回数</span></div>
      <div class="text-bold text-lg">{{ summaryRecord.pack_sell_stock_count }}</div>
    </div>
    <div class="text-center">
      <div><span class="mx-4 border-b text-sm">品目数</span></div>
      <div class="text-bold text-lg">{{ summaryRecord.pharmacy_medicine_count.toLocaleString() }}</div>
    </div>
    <div class="text-center">
      <div><span class="mx-4 border-b text-sm">廃棄金額(税込み)</span></div>
      <div class="text-bold text-lg">\{{ summaryRecord.delete_price.toLocaleString() }}</div>
    </div>
    <div class="text-center">
      <div><span class="mx-4 border-b text-sm">廃棄数</span></div>
      <div class="text-bold text-lg">{{ summaryRecord.delete_number.toLocaleString() }}</div>
    </div>
    <div class="text-center">
      <div><span class="mx-4 border-b text-sm">不動品金額(税込み)</span></div>
      <div class="text-bold text-lg">\{{ summaryRecord.pharmacy_medicine_old_price.toLocaleString() }}</div>
    </div>
    <div class="text-center">
      <div><span class="mx-4 border-b text-sm">不動品目数</span></div>
      <div class="text-bold text-lg">{{ summaryRecord.pharmacy_medicine_old_count.toLocaleString() }}</div>
    </div>
  </div>
  <div class="w-full mt-1 mb-5">
    <div class="font-bold">【品目別】</div>
    <custom-list
      ref="listMedicineSummaryJanRef"
      :api-url="apis.summary_stock_list"
      :table-fields="medicineSummaryJanFields"
      :option-fields="searchParamsJanData"
      :is-downloadable="true"
      font-size="0.8em"
      height="60vh"
    >
    <template v-slot:item="slotProps">
      <summary-medicine-component
        :apis="apis"
        :item="slotProps.item"
        :fields="medicineSummaryJanFields"
      ></summary-medicine-component>
    </template>
    </custom-list>
  </div>

  <div class="w-full mt-1 mb-5">
    <div class="font-bold">【月別在庫金額】</div>
    <custom-list
      ref="listMedicineSummaryAggregateRef"
      :api-url="apis.summary_stock_aggregate_summary_list"
      :table-fields="medicineSummaryAggregateFields"
      :option-fields="searchParamsAggregateData"
      :is-downloadable="true"
      font-size="0.8em"
      height="20vh"
    >
    <template v-slot:item="slotProps">
      <td v-for="(medicineSummaryAggregateFields,index) in medicineSummaryAggregateFields" :key="index" :style="'width:' + medicineSummaryAggregateFields.width" class="text-center">
        <div v-if="medicineSummaryAggregateFields.field_key == 'pharmacy_name'" class="text-left">
          {{ slotProps.item.pharmacy_name }}
        </div>
        <div v-else-if="medicineSummaryAggregateFields.field_key == 'aggregate_date'">
          {{ slotProps.item.aggregate_date }}
        </div>
        <div v-else-if="medicineSummaryAggregateFields.field_key == 'stock_price'">
          \{{ slotProps.item.stock_price.toLocaleString() }}
        </div>
        <div v-else-if="medicineSummaryAggregateFields.field_key == 'prescript_price'">
          \{{ slotProps.item.prescript_price.toLocaleString() }}
        </div>
        <div v-else-if="medicineSummaryAggregateFields.field_key == 'month_avg'" class="text-right">
          {{ (slotProps.item.month_avg ? slotProps.item.month_avg : 0) }}
        </div>
      </td>
    </template>
    </custom-list>
  </div>
  <div class="w-full mt-1 flex flex-col summary-chart2">
    <div v-for="(summaryChartStockAggregateRecord,index) in summaryChartStockAggregateData" :key="index">
      <div class="font-bold">【在庫月数】</div>
      <div class="w-full">
        <chart
          chart-type="bar"
          height="280px"
          :chart-data="summaryChartStockAggregateRecord"
        ></chart>
      </div>
    </div>
  </div>
  <div class="w-full mt-1 flex flex-row summary-chart1">
    <div class="w-1/5" v-for="(summaryChartRecord,index) in summaryChartData" :key="index">
      <div class="font-bold">【取引金額割合】</div>
      <div>
        <chart
          chart-type="pie"
          height="280px"
          :chart-data="summaryChartRecord"
        ></chart>
      </div>
    </div>
    <div class="w-4/5 pl-4" v-for="(summaryChartHistoryRecord,index) in summaryChartHistoryData" :key="index">
      <div class="font-bold">【時系列(金額)】</div>
      <div class="w-1/5">
        <select-box
          :value="summaryHistoryType"
          :options="summaryHistoryOptions"
          :on-change="onSummaryHistoryTypeChange"
        ></select-box>
      </div>
      <div class="w-full">
        <chart
          chart-type="bar"
          height="280px"
          :chart-data="summaryChartHistoryRecord"
        ></chart>
      </div>
    </div>
  </div>
</div>
</template>

